import React, {Component} from 'react';
import {Chip} from '@material-ui/core';

const DIR_SYMBOL = {forward: '→', backward: '←', bidirectional: '↔'};

/** Read-only connections table (editing is graph-view-only). */
class ConnectionsTable extends Component {
  render() {
    const {rows, labelIndex} = this.props;

    return (
      <div className="lt-section">
        <div className="lt-section-header">
          <span className="lt-section-title">Connections</span>
        </div>
        <table className="data-table lt-table">
          <thead>
            <tr>
              <th>Source</th>
              <th>Direction</th>
              <th>Target</th>
              <th>Label</th>
              <th>Auto</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={5} className="lt-empty-row">No connections.</td></tr>
            )}
            {rows.map((e) => {
              const isAuto = !!(e.data && (e.data.autoCreated || e.data.autoDerived));
              return (
                <tr key={e.id} data-testid={`lt-conn-row-${e.id}`}>
                  <td>{labelIndex[e.source] || e.source}</td>
                  <td>{DIR_SYMBOL[e.direction] || '→'}</td>
                  <td>{labelIndex[e.target] || e.target}</td>
                  <td>{e.label || '—'}</td>
                  <td>{isAuto ? <Chip label="auto" size="small" className="lt-auto-chip" /> : ''}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ConnectionsTable;
